import React from 'react';
import { Box } from '@mui/material';
import BaseShimmer from './BaseShimmer';
import './shimmer.scss';

function HeroShimmer({
  showButtons = true,
  showSubtitle = true,
  className = '',
  style = {},
}) {
  return (
    <Box className={`shimmer-hero ${className}`} sx={style}>
      <BaseShimmer
        className="shimmer-hero-title"
        height="48px"
        width="60%"
        borderRadius="8px"
      />

      {showSubtitle && (
        <BaseShimmer
          className="shimmer-hero-subtitle"
          height="20px"
          width="40%"
          borderRadius="6px"
        />
      )}

      {showButtons && (
        <Box className="shimmer-hero-buttons">
          <BaseShimmer
            className="shimmer-hero-button"
            height="42px"
            width="140px"
            borderRadius="6px"
          />
          <BaseShimmer
            className="shimmer-hero-button"
            height="42px"
            width="140px"
            borderRadius="6px"
          />
        </Box>
      )}
    </Box>
  );
}

export default HeroShimmer;
